// Shared intake allowlists; shipped with both the client and trusted backend.
import options from '../../../functions/attorneyApplicationOptions.json';

export const jurisdictions = options.jurisdictions;
export const practiceAreas = options.practiceAreas;

export const acknowledgmentVersion = options.acknowledgmentVersion;
export const understandings = options.understandings;
